import { render } from "./support-bundle-image.vue?vue&type=template&id=f30cb814"
import script from "./support-bundle-image.vue?vue&type=script&lang=js"
export * from "./support-bundle-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__